<template>
  <div class="search-box">
    <van-sticky>
      <div class="nav">
        <img src="../../assets/nav/yz_nav_fh.png" class="fh" @click="$router.back()">
        <div class="input-box">
          <img src="../../assets/nav/yz_nav_ss.png">
          <input v-model="state.value" type="text" placeholder="请输入群聊名称" @input="inputChange" />
        </div>
        <div class="text" @click="onSearch">
          搜索
        </div>
      </div>
    </van-sticky>
    <div class="search-content">
        <div class="search-box">
          <van-list v-model:loading="state.loading" :finished="state.finished" finished-text="没有更多了" @load="onLoad">
            <van-cell v-for="(item, i) in state.teamDate" :key="i + '-list'">
              <template #value>
                <div class="groupMsg">
                  <div class="group_left">
                    <div class="groupAvatar">
                      <img :src=item.avatar alt="">
                      <img src="../../assets/chat/chat_authority01.png" alt="" class="authority">
                    </div>
                    <div class="groupInfo">
                      <h3>{{ item.name }}</h3>
                      <p>{{ item.memberNum }}人</p>
                    </div>
                  </div>
                  <button @click="goThisGroup(item.teamId)">
                    进入
                  </button>
                </div>
              </template>
            </van-cell>
          </van-list>
        </div>
      </div>
    </div>
</template>
<script>
import { reactive, onMounted, onDeactivated,onActivated} from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from "vuex";
import SDK from "@yxim/nim-web-sdk";
import { Toast } from 'vant';
import { searchGroup } from '@/api/chat'; 

export default {
  name: 'search',
  setup() {
    const store = useStore();
    const router = useRouter()
    const state = reactive({
      show: true,
      value: '',
      hotgamelist: [],
      historylist: [],
      nim: null,
      teamDate:[],

      loading:false,
      finished:true
    })

    // 返回
    const onClickLeft = () => {
      router.back()
    }

    // 监控输入框输入值的变化
        const inputChange = (e) => {
          // console.log(state.value)
          state.teamDate=[]
        }

    // 搜索群聊
      const onSearch=()=>{
        // console.log('搜索群聊')
        pagecode=1
        totalpage=1
        state.finished = false;
        state.loading = false;
        state.teamDate=[]
        onLoad()
      }   
      
      // 搜索群聊
      const  searchData=()=>{  
        // console.log('重新搜索------',pagecode,totalpage)
        // 搜索群聊
        searchGroup({
          pagecode:pagecode,
          username:store.state.wyAccount,
          groupname:state.value
        }).then(res=>{
          // console.log('搜索群聊返回的接口------------',res)
          let date=res.data
          totalpage=date.data.total_page
          if(date.code=='1'){
            if(pagecode>totalpage){
                state.finished=true
                return
              }
            // console.log(date.data.lists)
              // 根据群组id获取群组信息
              date.data.lists.forEach(item=>{
                state.nim.getTeam({
                  teamId:item.groupid,
                  done:getTeamDone
                })
              })

              // console.log(pagecode,totalpage)
              // 是否分页
            
              pagecode++
          }else{
            state.loading = false;
            state.finished = true;
          }
        })
      }

      // 云信返回的群聊详细信息
      const getTeamDone=(err,obj)=>{
        // console.log('获取群'+(!err?'成功':'失败'))
        // console.log(obj)
        // 将获取到的群组信息添加到搜索结果中
        state.teamDate.push(obj)
        console.log('搜索到的群结果----------',state.teamDate)
        // 除去teamid一样的数据

      }

      var pagecode=1;
      var totalpage=1
      const onLoad=()=>{
        searchData()
      }

      //进入群聊
      const goThisGroup=(groupId)=>{
        console.log('进入群聊'+groupId)
        state.nim.applyTeam({
          teamId: groupId,
          done: function(err, obj) {
            console.log('申请加入群聊' + JSON.stringify(obj))
            if (err) {
              console.log(err)
              if(err.code==809){
                // Toast.fail('已经在群里了')
                router.push({ path: "/simpleChat", query: { groupId: groupId} })
              }
            } else {
              console.log(obj)
              // 申请成功后跳转到群聊页面
              router.push({ path: "/simpleChat", query: { groupId: groupId } });
            }
          }
        })
      }

    onMounted(() => {
      console.log('onMounted搜索' + localStorage.getItem('SearchList'))
      // window.JsBridge.hindBottomTab()
      var hisArr = []
      hisArr = (JSON.parse(localStorage.getItem('SearchList')))
      let set = new Set(hisArr);
      hisArr = Array.from(set);
      hisArr = hisArr.slice(0, 8)
      state.historylist = hisArr

      // 初始化群聊信息
      state.nim = SDK.NIM.getInstance({
        // 初试化SDK
        debug: true,
        appKey: store.state.appKey,
        account:store.state.wyAccount,
        token:store.state.wyToken,
        debugLevel: 'debug',
        db: false,
      })
    });

    onActivated(()=>{
      console.log('activited执行力--------------')
      // window.JsBridge.hindBottomTab()
    })

    // 失活时清空全部信息
    onDeactivated(()=>{
      state.value='',
      state.teamDate=[]
    })
   

    return {
      state,
      onClickLeft,
      inputChange,
      onSearch,
      goThisGroup,
      onLoad,
      getTeamDone,
      searchData
    }
  }
};
</script>
<style scoped src="../../styles/removeVantcell.css"></style>
<style scoped="scoped">
.nav {
  /* background-color: #fff; */
  background: linear-gradient(#e4e4e4 0%, #fff 100%);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 32px;
  padding-top: calc(32px + constant(safe-area-inset-top));
  /* 适配安全区域 iOS < 11.2 */
  padding-top: calc(32px + env(safe-area-inset-top));
  /* 适配安全区域 iOS >= 11.2 */
  position: fixed;
  width: 100%;
}

.nav .fh {
  width: 60px;
  height: 60px;
  margin-right: 32px;
}

.nav .input-box {
  flex: 1;
  width: 100%;
  padding: 20px 36px;
  background: #e3e3e3;
  border-radius: 20px;
  display: flex;
  align-items: center;
}

.nav .input-box img {
  width: 36px;
  height: 36px;
}

.nav .input-box input {
  background: #e3e3e3;
  border: 0px;
  width: 100%;
  padding-left: 18px;
  font-size: 28px;
}

.nav .text {
  font-size: 32px;
  color: #333333;
  margin-left: 24px;
}

.search-box {
  /* background-color: #55a1d7; */
  /* min-height: 100vh; */
}


.search-content {
  padding-top: calc(132px + constant(safe-area-inset-top));
  /* 适配安全区域 iOS < 11.2 */
  padding-top: calc(132px + env(safe-area-inset-top));
  /* 适配安全区域 iOS >= 11.2 */
  background-color: #fff;
  padding-top: 180px;
  padding-left:32px;
  height: 100vh;
}

.groupMsg{
  width: 686px;
  height: 160px;
  background-color: #f7f7f7;
  border-radius: 20px;
  padding:30px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
.groupAvatar {
  display: flex;
  position: relative;
}
.groupAvatar img{
  width: 100px;
  height: 100px;
  border-radius: 50%;
}
.groupMsg button{
  width: 112px;
  height: 58px;
  background-color:#9C85FB ;
  border:0;
  color: #fff;
  border-radius: 58px;
}
.groupInfo{
  margin-left: 24px;
  padding-top: 8px;
}
.groupInfo h3{
  font-size: 28px;
  color: #333333;
}
.groupInfo p{
  font-size: 24px;
  color: #999999;
  margin-top: 10px;
}
.groupAvatar .authority{
  width: 40px;
  height: 40px;
  position: absolute;
  left: 60px;
  top: 60px;
}
.group_left{
  display: flex;
}
.search-box{
  height: 100%;
  background-color: #fff;
  overflow: auto;
}
</style>